import { Component, EventEmitter, Input, OnChanges, OnInit, Output, QueryList, SimpleChanges, ViewChildren } from '@angular/core';
import { ColumnSortingDirective } from 'src/app/_directives/column-sorting.directive';
import { IColumnSortEvent } from 'src/app/_interfaces/i-column-sort-event';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit, OnChanges {

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.list?.currentValue?.some(l => l.download)){
      this.isDownloadable = true;
    }
    if(changes.list?.currentValue?.some(l => l.upload)){
      this.isUploadable = true;
    }
  }

  ngOnInit(): void {
  }

  @Input() list:any[];
  @Input() headers: string[];
  @Input() isResponsive: boolean = true;
  @Input() isDownloadable: boolean = false;
  @Input() isUploadable: boolean = false;
  @Input() routeTo:string[];
  @Input() buttons: {name: string, class?: string, iconClass?: string, header?: string}[] = [];
  @Output() rowSelected:EventEmitter<any> = new EventEmitter();
  @Output() downloadClicked:EventEmitter<any> = new EventEmitter();
  @Output() viewFilesClicked:EventEmitter<any> = new EventEmitter();
  @Output() buttonClicked:EventEmitter<{event: any, buttonName: string, rowData: any}> = new EventEmitter();
  @ViewChildren(ColumnSortingDirective)
  tableHeaders: QueryList<ColumnSortingDirective>;

  compare = (v1: string | number, v2: string | number) =>
    v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

  onSort({ column, direction }: IColumnSortEvent) {
    // resetting other headers
    this.tableHeaders.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    // sorting countries
    if (direction == '' || column === '') {
      this.list = this.list;
    } else {
      this.list = [...this.list].sort((a, b) => {
        const res = this.compare(a[column], b[column]);
        return direction === 'asc' ? res : -res;
      });
    }
  }

  rowClicked(rowData:any)
  {
    this.rowSelected.emit(rowData);
  }

  ondownloadClicked(event, rowData:any)
  {
    this.downloadClicked.emit({event, rowData});
  }

  onviewFilesClicked(event, rowData:any)
  {
    this.viewFilesClicked.emit({event, rowData});
  }

  isArray(item:any){
    return Array.isArray(item);
  }

  onButtonClick(event, button, rowData:any){
    this.buttonClicked.emit({event, buttonName: button.name, rowData})
  }
}
